// extracted by mini-css-extract-plugin
export default {"container":"RoomLoading_container__YS7I-"};